module.exports = __webpack_public_path__ + "static/media/Portolog.1553ba25.png";